import { BaseRouteService } from 'core/services';

class ProductInventoryRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'product-inventories/';
	}
	
	createBatch(sourceOfChange) {
		return super.create(this.base + 'batch/?sourceOfChange={sourceOfChange}', {sourceOfChange});
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}

	sync() {
		return super.create(this.base + 'sync');
	}
}

export default ProductInventoryRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/ProductInventoryRouteService.js